"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configureAssetData = void 0;

var _react = require("react");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _annotations = require("../selectors/annotations");

var _constants = require("../constants");

var _comments = require("../actions/comments");

var _reducers = require("../reducers");

var _context = require("../actions/context");

var _usePrevious = _interopRequireDefault(require("./usePrevious"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PRESERVED_KEYS = ['isSaving'];

var configureAssetData = function configureAssetData() {
  var assetData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!assetData.id) {
    return PRESERVED_KEYS.reduce(function (result, key) {
      if (Object.prototype.hasOwnProperty.call(assetData, key)) {
        result[key] = assetData[key];
      }

      return result;
    }, {});
  }

  var assetPrefixCcxRegion = "".concat(_constants.ASSET_PREFIX_CCX).concat(assetData.region || 'us', ":");
  var id = assetData.id,
      ownerId = assetData.ownerId,
      type = assetData.type,
      useNodeIndex = assetData.useNodeIndex,
      validNodes = assetData.validNodes,
      nodeId = assetData.nodeId;

  if (useNodeIndex) {
    var tempNodeId = nodeId;
    assetData.nodeId = !isNaN(Number(tempNodeId)) ? Number(tempNodeId) : tempNodeId;
  }

  var allNodes = [];

  if (validNodes) {
    allNodes = validNodes.map(function (node, index) {
      if (useNodeIndex) {
        node.id = index;
      }

      return node;
    });
  }

  return _objectSpread(_objectSpread({}, assetData), {}, {
    validNodes: allNodes,
    id: !id || id.indexOf(_constants.ASSET_PREFIX) !== -1 ? id : assetPrefixCcxRegion + id,
    ownerId: !ownerId || ownerId.indexOf(_constants.USER_ID_PREFIX) !== -1 ? ownerId : _constants.USER_ID_PREFIX + ownerId,
    type: type || 'application/vnd.adobe.directory+json'
  });
};

exports.configureAssetData = configureAssetData;

var useAssetData = function useAssetData(assetData, annotationsMultiPageEnabled) {
  var prevAssetData = (0, _usePrevious.default)(configureAssetData(assetData)) || {};
  var dispatch = (0, _reducers.useDispatch)();
  var hasAnnotationLocation = (0, _reducers.useSelector)(_annotations.getHasAnnotationLocation); // Memoize standardized asset data

  var configuredAssetData = (0, _react.useMemo)(function () {
    var newAssetData = configureAssetData(assetData);

    if (!(0, _lodash.default)(prevAssetData, newAssetData)) {
      return newAssetData;
    }

    return prevAssetData;
  }, [assetData, prevAssetData]);
  (0, _react.useEffect)(function () {
    if (prevAssetData.nodeId !== configuredAssetData.nodeId && !annotationsMultiPageEnabled) {
      if (hasAnnotationLocation) {
        // if nodeId is changing and an annotation is in progress, save it.
        dispatch((0, _context.contextSaveAnnotationLocation)(undefined, prevAssetData.nodeId));
      } else {
        // if nodeId is changing and an annotation hasn't yet been placed, cancel it.
        dispatch((0, _context.contextSetAnnotationMode)(false));
      }
    }

    if (prevAssetData.id && prevAssetData.id !== configuredAssetData.id) {
      dispatch((0, _comments.commentsFilterClear)());
    } // We only want to run this when nodeId changes.

  }, [annotationsMultiPageEnabled, configuredAssetData, dispatch, hasAnnotationLocation, prevAssetData.id, prevAssetData.nodeId]);
  return configuredAssetData;
};

var _default = useAssetData;
exports.default = _default;